const serviceAgreementFCnuvemManagedServices = `
    <table align="center" cellpadding="0" cellspacing="0" width="600" style="border-collapse: collapse;">
    <tr>
    <td>
        <img height="85" width="150" src="https://blobbillingfiles.blob.core.windows.net/imgshared/fcnuvem.png">
    </td>
    </tr>
    <tr>
    <td align="center" height='100px'>
        <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS
        </strong></p>
    </td>
    </tr>
    <br />
    <tr>
    <td>
        <br />
        <p>
        Pelo presente instrumento particular, em que são partes, {{companyname}}, com sede na {{companyaddress}}, nº
        {{companynumber}}, bairro {{companydistrict}}, {{companycity}}/{{companystate}}, inscrita no CNPJ/MF sob o nº
        {{companycnpj}}, neste ato devidamente representada, em conformidade com contrato
        social, por seu representante legal infra-assinado, doravante denominada CONTRATANTE e de outro lado, FCAMARA
        CONSULTORIA E FORMAÇÃO EM INFORMÁTICA LTDA., inscrita no CNPJ/MF sob o nº 03.775.758/0001-90, estabelecida à Rua
        Bela Cintra, nº 986 – 2º andar, CEP: 01415-906 - Consolação - São Paulo/SP, neste ato devidamente representada,
        em conformidade com seu Contrato Social, por seu representante legal infra-assinado, doravante denominada
        CONTRATADA.
        </p>
        <p>
        As Partes de comum acordo e por meio de seus representantes legais infra-assinados resolvem firmar o presente
        <strong> CONTRATO DE PRESTAÇÃO DE SERVIÇOS, </strong> que se regerá segundo as cláusulas e condições a seguir
        previstas:
        </p>
        <p>
        <strong> CLÁUSULA PRIMEIRA – DO OBJETO </strong>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            1.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O presente Contrato tem por objeto disciplinar a contratação da <strong> CONTRATADA </strong> pela <strong>
                CONTRATANTE, </strong> para a prestação de serviços de suporte.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            1.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Os serviços contemplados por este instrumento estão descritos de forma detalhada, com as definições e
            abrangência dos serviços, prazos, preços e demais características inerentes à prestação de serviços
            objetivada, na Proposta Comercial anexa (“Anexo”) a este instrumento, que após serem rubricadas pelas
            Partes, farão parte integrante e inseparável do presente instrumento.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA SEGUNDA – DAS OBRIGAÇÕES DA CONTRATADA </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            2.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Durante o prazo de vigência deste Contrato e sem prejuízo das demais obrigações assumidas, a <strong>
                CONTRATADA </strong> se obriga a:
            <p>
            <table>
                <tr>
                <td valign=top>
                    a) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Executar os serviços contratados com níveis técnicos de qualidade adequados e de acordo com as
                    especificações, prazos e condições contratadas;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    b) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Não contratar mão-de-obra e trabalho infantil de quaisquer espécies em nenhuma ocasião, tampouco se
                    servir da contratação de recursos decorrentes de trabalho escravo, no exercício das atividades
                    decorrentes do presente contrato.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    c) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Executar as tarefas que lhe competem, e que são objeto deste Contrato, utilizando-se de profissionais
                    especializados e em número suficiente para a satisfação das necessidades do serviço;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            <p>
            <table>
                <tr>
                <td valign=top>
                    d) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Manter atualizados seus dados cadastrais junto à <strong> CONTRATANTE, </strong> informando todas e
                    quaisquer alterações eventualmente ocorridas, principalmente dados bancários, prestando tais
                    informações sempre por escrito à <strong> CONTRATANTE. </strong>
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            2.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Caso a CONTRATANTE ou terceiros venham a modificar o produto e/ou serviço final, a CONTRATADA não se
            responsabilizará por quaisquer danos causados ao sistema oficialmente fornecido.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <strong> CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DA CONTRATANTE </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            3.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Fornecer à CONTRATADA, dos prazos previstos no cronograma das atividades constantes na Proposta Comercial
            anexa, exigirá o atendimento pela CONTRATANTE, quando requerido, das solicitações de informações, dados
            técnicos, documentos e pessoal indispensáveis à execução do objeto deste contrato, no prazo requerido pela
            CONTRATADA. Caso a CONTRATANTE, para atendimento das solicitações indispensáveis à prestação de serviços,
            não observe o prazo indicado pela CONTRATADA, esta estará autorizada a majorar, sem qualquer ônus, os prazos
            previstos no cronograma, em conformidade com o tempo de tal atraso;
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            3.2 &nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Pagar, à <strong> CONTRATADA, </strong> pela prestação dos serviços, nos prazos e condições previstas neste
            Contrato;
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            3.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Indicar um ou mais colaboradores que se encarregarão de acompanhar os representantes indicados pela
            CONTRATADA sempre que necessário à execução dos serviços, quando aplicável. Da mesma forma, um elemento de
            contato será indicado como ponto focal para todos os assuntos envolvendo a contratação;
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            3.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A <strong> CONTRATANTE </strong> se responsabilizará por todo e qualquer dano de ordem moral ou material,
            causados por seus prepostos ou atos de gerência incompatíveis com o objeto deste contrato praticados perante
            à <strong> CONTRATADA, </strong> independentemente de dolo ou culpa.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA QUARTA – DOS PREÇOS E FORMA DE PAGAMENTO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Pelos serviços contratados a CONTRATANTE pagará a CONTRATADA o valor correspondente e constante das
            Propostas Comerciais e respectivas Notas Fiscais de Serviços a serem enviadas. O Pagamento será feito com
            vencimento no mês subsequente à prestação de serviços.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O pagamento do serviço realizado será efetuado mediante a apresentação de Nota Fiscal e fatura
            correspondente, a ser emitida até o 20º dia de cada mês, pagável até o dia 30 (trinta) do mês subsequente ao
            mês de Prestação de Serviços. Esse pagamento será efetuado por intermédio de crédito em conta corrente da
            CONTRATADA a ser previamente informada por escrito, servindo o recibo de depósito como comprovante de
            pagamento, ou por intermédio de boleto bancário, a ser enviado juntamente com a nota fiscal.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Após o encerramento da competência do mês vigente da prestação de serviços e do término da execução dos
            serviços, a CONTRATANTE realizará o aceite tácito na fatura enviada referente aos valores apurados no que
            concerne à medição dos serviços prestados.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A <strong> CONTRATANTE </strong> terá até 5 (cinco) dias após o recebimento das Notas Fiscais para realizar
            qualquer contestação sobre elas, caso não haja nenhuma contestação por parte da <strong> CONTRATANTE
            </strong> a fatura será assumida e incontestável.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A <strong> CONTRATADA </strong> é responsável por todos os tributos e taxas, sendo certo que todos já foram
            considerados no preço. Por ocasião dos pagamentos, a <strong> CONTRATADA </strong> providenciará a
            indicação, na Nota Fiscal de Serviços, para fins de retenção, de todos os tributos aplicáveis à espécie,
            cabendo o seu recolhimento pela parte Contribuinte, determinada em legislação específica.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.6 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Qualquer majoração dos tributos incidentes sobre o serviço objeto deste Contrato, e que ocorra durante a
            vigência do presente contrato, implicará, igualmente, na majoração proporcional dos valores, majoração esta
            que será previamente informada pela <strong> CONTRATADA </strong> à <strong> CONTRATANTE. </strong>
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.7 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Havendo necessidade de horas adicionais não previstas, complementos na especificação de análise realizada
            pela <strong> CONTRATANTE, </strong> solicitação de novos serviços que venham a gerar alterações no escopo,
            funcionamento ou entendimento do serviço contratado, a <strong> CONTRATADA </strong> irá apresentar um novo
            levantamento onde os impactos funcionais e consequentemente os novos prazos e custos para o desenvolvimento
            do projeto serão apresentados. Este processo automaticamente ocasionará a paralisação do tempo de projeto,
            não sendo considerado atraso, e caberá a <strong> CONTRATADA </strong> apresentar uma nova data para o
            “start” do projeto a ser revisto e aprovado pela <strong> CONTRATANTE. </strong>
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.8 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O atraso no pagamento obrigará a CONTRATANTE ao pagamento, além do valor principal indicado no documento
            fiscal encaminhado pela CONTRATADA, de juros de mora de 1% (um por cento) ao mês, multa de 2% (dois por
            cento) e atualização calculada pelo IPC-A pro rata temporis, calculados sobre a totalidade do débito vencido
            e não pago, desde a data do vencimento até a do efetivo pagamento.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.9 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A impontualidade, por parte da CONTRATANTE por mais de 30 (trinta) dias no pagamento de qualquer valor
            devido à CONTRATADA, constituirá infração contratual, podendo a CONTRATADA considerar rescindido o presente
            Contrato, cobrando todos os valores referentes a serviços já prestados e ainda não pagos, , além disso, a
            CONTRATANTE terá os serviços contratados imediatamente interrompidos e poderá ter seu(s) título(s)
            protestado(s) e a inclusão nos órgãos de proteções de crédito.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.10 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Findo o prazo estabelecido, havendo interesse das partes na renovação do presente contrato deverão fazê-lo
            por escrito, sendo certo que o índice a ser aplicado em eventual reajuste será o IGP-M.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            4.11 &nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O presente Contrato serve como título executivo extrajudicial para a cobrança dos valores devidos.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA QUINTA – DA ANTICORRUPÇÃO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            5.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Cada Parte declara a outra Parte e garante que não violou nem violará quaisquer leis ou regulamentos
            relativos ao seu negócio e a este Contrato, incluindo, mas não se limitando a leis e regulamentos relativos
            à anticorrupção, suborno, extorsão, propina (coletivamente as "Leis Anticorrupção"), ou questões similares
            que sejam aplicáveis às suas atividades comerciais em conexão com este Contrato, e que não aceitará nenhuma
            ação que fará com que viole quaisquer dessas leis. Especificamente e sem limitação de nenhuma forma, as
            Partes declaram e garantem que não fizeram, nem farão oferta, pagamento, transferência, ou promessa a
            qualquer pessoa que tenha o propósito ou efeito de suborno, aceitação ou consentimento de extorsão,
            "propinas" ou outros meios impróprios ou ilegais de obter ou reter negócios em relação a este Contrato e as
            obrigações aqui estabelecidas.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            5.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes reconhecem que estão sujeitas a Lei nº 12.846/2013 (Lei Anticorrupção) e concordam em agir de
            maneira a permitir que a Parte inocente cumpra esta lei em conexão com as obrigações assumidas neste
            Contrato.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            5.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A não observância das disposições desta Cláusula dará à Parte inocente o direito de imediatamente rescindir
            este Contrato, bem com a ser indenizada pela Parte infratora por todos e quaisquer custos, multas e/ou
            penalidades que venha a comprovadamente incorrer como consequência de tais ações e/ou omissões.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA SEXTA – DO PRAZO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            6.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O presente contrato terá vigência de 12 (doze) meses, contados a partir da data da sua assinatura.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            6.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Após o período mínimo de 12 (doze) meses, a CONTRATADA poderá alterar seus valores de serviço, momento em
            que a CONTRATANTE poderá rescindir este contrato, mediante aviso prévio de 30 (trinta) dias.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            6.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Caso nenhuma Parte se manifeste em contrário, após o período mínimo de vigência mencionado, o contrato será
            renovado automaticamente por igual período.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA SÉTIMA – DO SIGILO, CONFIDENCIALIDADE E RESPONSABILIDADE </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes se obrigam a envolver em projetos e tratativas apenas os funcionários, prepostos, representantes,
            prestadores de serviço que de fato precisem ter acesso a tal informação.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes envolvidas nessa relação contratual deverão manter o mais absoluto sigilo com relação a todas as
            informações, atos e documentos desenvolvidos/ocorridos/praticados durante o projeto de que trata este
            Contrato, devendo ocorrer o mesmo com relação a materiais, produtos, sistemas, técnicas, estratégias,
            métodos de operação, pormenores, inovações, segredos comerciais, marcas, criações, especificações técnicas e
            comerciais, qualificados como confidenciais, doravante denominados simplesmente INFORMAÇÕES CONFIDENCIAIS.
            Comprometendo-se, outrossim, a Parte que tiver acesso a tais informações, a não revelar, reproduzir,
            utilizar ou dar conhecimento, em hipótese alguma, a terceiros dispensáveis à essa relação contratual, bem
            como, as Partes se comprometem a não permitir que nenhum de seus diretores, funcionários, contratados,
            subcontratados e/ou prepostos façam uso indevido das informações que detenha acesso.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As obrigações de sigilo e confidencialidade previstas nesta cláusula vincularão as Partes durante a vigência
            deste Contrato e continuarão na hipótese de seu término, independentemente do motivo por que este venha a
            ocorrer. O seu desrespeito por parte de quaisquer delas possibilitará a imediata rescisão deste Contrato e
            implicará a responsabilização por danos comprovadamente causados em regular processo administrativo ou
            judicial, inclusive a terceiros. Qualquer reclamação judiciária ou extrajudiciária será interposta dentro do
            prazo de um ano a contar a partir do momento em que ocorreu o fato em que a reclamação se sustente.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes se obrigam a não utilizar, em proveito próprio ou de terceiros, as informações que venham a obter
            junto à outra Parte em razão do serviço objeto deste contrato, por si e por seus prepostos ou funcionários,
            haja vista reconhecerem que referidas informações se revestem de total e irrestrita confidencialidade e,
            como tal, devem ser qualificadas e consideradas, sob pena de responsabilidade civil e/ou penal.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>
                A CONTRATANTE aceita que a CONTRATADA faça uso de suas marcas, assim como de seu logo ou nome comercial e
                da referência do projeto que a CONTRATADA executará, com a finalidade de identificá-la como “Cliente” da
                CONTRATADA e realizar atividades promocionais.
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    7.5.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    A autorização de uso será válida em todo território nacional e internacional, em todas as modalidades
                    de uso, desde que respeitada a legislação estabelecida no território da divulgação, sem trazer nenhum
                    prejuízo moral ou penal à CONTRATANTE.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    7.5.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    As divulgações, incluem, mas não se limitam, às seguintes formas: uso permitido em seu site e qualquer
                    outra forma de mídia, inclusive em campanhas publicitárias, de cunho jornalístico, produções
                    fotográficas, audiovisuais, em blogs, sites, materiais impressos, programas televisivos, publicações
                    internas, redes sociais e qualquer outra forma de uso ou reprodução de imagem.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    7.5.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    A CONTRATADA declara que a CONTRATANTE é detentora de todos os direitos autorais patrimoniais e morais
                    da marca, permitindo o seu uso para a publicação, por prazo indeterminado, sem que haja nenhum
                    desrespeito aos direitos autorais.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    7.5.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Todos os modos de divulgação mencionados serão de custo da CONTRATADA, sendo que, as divulgações aqui
                    pretendidas serão de bom grado da CONTRATANTE, podendo, no momento de eventuais depoimentos e/ou
                    entrevistas, recursar-se, a qualquer momento, de colaborar para tanto. As divulgações pretendidas
                    deverão obedecer aos princípios da boa fé e dos bons costumes.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    7.5.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Em caso de violação da presente cláusula, a CONTRATADA responderá pelos danos que comprovadamente der
                    causa, mediante apuração em devido processo legal.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.6 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A obrigação de confidencialidade contida nesta cláusula permanecerá em vigor mesmo após o vencimento ou
            rescisão do presente instrumento, pelo prazo de 3 (três) anos.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.7 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>
                As Partes utilizarão todas as medidas ao seu alcance para a proteção das Informações Confidenciais,
                obtendo de seus funcionários e/ou prepostos locados na prestação dos serviços, igual comprometimento às
                regras aqui estipuladas, para evitar que as INFORMAÇÕES CONFIDENCIAIS sejam, de qualquer modo, divulgados,
                revelados, publicados, vendidos, cedidos, locados, arrendados, ou de qualquer outra maneira alienados ou
                explorados por qualquer outro terceiro, devendo devolver as informações às quais tiver acesso por força de
                suas atividades.
            </p>

            <p>
                Parágrafo Primeiro - As obrigações e deveres especificados pelos itens acima da presente cláusula 8ª deste
                instrumento não se aplicam às informações que:
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    (a) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Sejam de domínio público, ou estejam disponíveis para o público de maneira geral antes de serem
                    recebidas pela Parte Receptora da Parte Emissora, ou que venham posteriormente a tornarem-se de
                    domínio público ou disponíveis de maneira geral para o público, antes de qualquer ação violadora da
                    Parte Receptora ou de um empregado ou agente da Parte Receptora;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    (b) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Estejam de posse da Parte Receptora, sem quebra de quaisquer obrigações aqui discriminadas perante a
                    Parte Emissora, antes do seu recebimento da Parte Emissora;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    (c) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Sejam recebidas pela Parte Receptora posteriormente através de terceiros, exceto se a Parte Receptora
                    tiver conhecimento ou tenha razões para tornar-se ciente de uma obrigação estabelecida entre terceiros
                    e a Parte Emissora, para manter segredo com respeito a tais informações;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    (d) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Sejam desenvolvidas pela Parte Receptora, antes das informações serem recebidas da Parte Emissora;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    (e) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Tenham sido previamente emitidas pela Parte Emissora a terceiros sem obrigação de manter segredo.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
                Parágrafo Segundo - Não obstante o disposto nesta cláusula, as Informações Confidenciais poderão ser
                reveladas por uma Parte Receptora:
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    (a) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Para aqueles empregados, agentes e consultores que necessitem do conhecimento dessas informações
                    relacionadas com suas funções profissionais, na forma e condições deste instrumento, e que estejam
                    obrigados a guardar tais Informações Confidenciais em confiança, restringindo sua utilização em
                    concordância com as obrigações da Parte Receptora conforme os termos deste Contrato;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    (b) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Na forma da lei, mediante solicitação judicial ou em processo administrativo, contanto que a Parte
                    Receptora notifique a Parte Emissora antes de tal revelação de modo a permitir que a Parte Emissora
                    apresente objeções ou procure amparo legal para impedir ou limitar o âmbito de tal revelação.
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            7.8 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Na hipótese da ocorrência da cláusula 8.2 supra ou em qualquer outra deste instrumento, independentemente do
            fundamento que qualifique o CONTRATANTE a reclamar descumprimento e/ou danos da CONTRATADA (incluindo, mas
            não se limitando a inadimplemento contratual, negligência, declaração falsa ou outra reivindicação
            contratual ou de responsabilidade civil extracontratual), a responsabilidade da CONTRATADA se limitará ao
            valor dos últimos de 3 (três) faturamentos realizados pela CONTRATADA. Em nenhum caso a CONTRATADA
            responderá por danos e prejuízos indiretos ou imateriais. A limitação e a exclusão de responsabilidades
            acima observarão a legislação vigente, em especial os art. 114 e 421 do Código Civil e a Lei 13.874/2019.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA OITAVA – DA RESCISÃO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            8.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O presente Contrato poderá ser rescindido de pleno direito, imediatamente por qualquer das Partes, se no
            prazo de 30 (trinta) dias contados a partir do recebimento da notificação pela outra Parte, assinalando o
            inadimplemento total ou parcial das obrigações assumidas neste Contrato, a Parte notificada não sanar,
            integralmente o inadimplemento apontado, respondendo a Parte Infratora aos danos que comprovadamente vier
            dar causa.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            8.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            <p>
                Além da hipótese prevista na cláusula anterior constituem, ainda, motivos para rescisão imediata do
                Contrato pela Parte prejudicada, independentemente de prévio aviso, a ocorrência de qualquer das situações
                abaixo:
            <p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    a) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Suspensão pelas autoridades competentes, da prestação do fornecimento contratado, em decorrência de
                    violação de dispositivos legais vigentes;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    b) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    Decretação de falência da outra parte, recuperação judicial, instauração de concurso de credores ou
                    dissolução/liquidação de qualquer uma das Partes;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>

            <p>
            <table>
                <tr>
                <td valign=top>
                    c) &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                </td>
                <td>
                    A ocorrência de caso fortuito ou de força maior, regularmente comprovada, impeditiva da execução do
                    Contrato. Quando for possível a execução apenas parcial do contrato, a <strong> CONTRATANTE </strong>
                    poderá decidir entre o cumprimento parcial e a rescisão do Contrato;
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp
                </td>
                </tr>
            </table>
            </p>
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>


        <p>
        <table>
        <tr>
            <td valign=top>
            8.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Independentemente do disposto acima, o presente Contrato poderá ser resilido por qualquer das partes,
            imotivadamente, mediante aviso prévio, por escrito, com 60 (sessenta) dias de antecedência, sem a incidência
            de qualquer penalidade, não cabendo qualquer direito à indenização, perdas e danos, ou qualquer outra forma
            de compensação. Nesse caso, cabe à CONTRATANTE o pagamento dos valores devidos em razão dos trabalhos já
            realizados até a data da efetiva rescisão.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA NONA - DA FORÇA MAIOR E CASO FORTUITO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Os casos fortuitos ou de força maior serão excludentes de responsabilidade na forma do artigo 393 do Código
            Civil Brasileiro, com exceção da atual pandemia que vivemos e da escassez de profissionais e/ou empresas
            especializadas.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A Parte que for afetada por caso fortuito ou motivo de força maior deverá notificar a outra, por escrito e
            em até 72 (setenta e duas) horas, da extensão do fato e do prazo estimado durante o qual estará inabilitada
            a cumprir ou pelo qual será obrigada a atrasar o cumprimento de suas obrigações decorrentes do Contrato,
            obrigando-se ainda a notificar a outra parte quando cessados os seus efeitos. Sendo certo que a CONTRATADA,
            a seu critério, poderá realizar a resilição do presente contrato, respeitando a premissa do item 8.3.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Se a ocorrência do caso fortuito ou motivo de força maior prejudicar apenas parcialmente a execução das
            obrigações oriundas do Contrato por uma das Partes, a Parte afetada deverá cumprir as obrigações que não
            tiverem sido afetadas pela ocorrência do caso fortuito ou motivo de força maior, desde que ainda exista
            interesse na continuidade do contrato pela outra parte.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As interrupções no fornecimento ou nos serviços decorrentes de força maior ou caso fortuito implicarão,
            quando cessados os seus reflexos, no estabelecimento de novos prazos e condições contratuais a serem
            ajustadas entre as Partes mediante termo aditivo, desde que a continuidade da prestação do fornecimento seja
            de interesse de ambas as Partes.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            9.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes anuem que será considerado como caso fortuito a indisponibilidade de profissionais e/ou empresas
            terceirizadas no mercado sob o escopo da presente prestação de serviço.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA DÉCIMA - NÃO SOLICITAÇÃO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            10.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Durante a vigência da contratação e pelo prazo de 1 (um) ano a contar do seu término, nenhuma das Partes
            poderá contratar funcionário(s), colaborador(es), e/ou prestador(ES) de serviço da outra, de forma direta ou
            indireta, nem tampouco lhe(s) fazer proposta(s) de trabalho, sem expressa anuência da outra parte. Em caso
            de não cumprimento dessa obrigação de NÃO FAZER, ficará resolvido de pleno direito o contrato existente
            entre as partes, devendo a parte infratora indenizar a outra no equivalente a 20 (vinte) vezes a remuneração
            percebida pelo(s) funcionário(s), colaborador(es), e/ou prestador(es) de serviço assediado(s) e/ou
            retirado(s) da equipe da Parte Inocente, além da indenização por perdas e danos provenientes da resolução
            contratual.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            10.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Para efeitos de cálculo da indenização mencionada nesta cláusula, a remuneração a ser adotada como base será
            aquela que o(s) funcionário(s), colaborador(es), e/ou prestador(es) de serviço obtiver na data da ocorrência
            do fato ou aquele constante em sua rescisão contratual, a que for maior. A base de cálculo será reajustada
            pelo IGP-M até o momento do pagamento da indenização.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA DÉCIMA PRIMEIRA - DAS DISPOSIÇÕES GERAIS </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Em todas as questões relativas ao Contrato, a CONTRATANTE e a CONTRATADA agirão como contratantes
            independentes. Nenhuma das Partes poderá declarar que possui qualquer autoridade para assumir ou criar
            qualquer obrigação, expressa ou implícita, em nome da outra Parte, nem representar a outra Parte como
            agente, funcionário, representante ou qualquer outra função. Fica desde já estabelecido que as Partes não
            têm nenhuma responsabilidade por dívidas e obrigações contraídas pela outra Parte, não podendo esta ou
            terceiros, utilizarem-se deste Contrato ou de qualquer outra razão para pleitear indenizações ou reembolsos.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Nenhuma das condições deste Contrato deve ser entendida como meio para constituir uma sociedade, joint
            venture, relação de parceria ou de representação comercial entre as Partes, nem ainda vínculo empregatício
            entre os empregados, prepostos, contratados e/ou subcontratados da CONTRATADA e da CONTRATANTE, sendo cada
            uma, única, integral e exclusivamente responsável por seus atos e obrigações.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Os serviços objeto do presente instrumento são contratados sem qualquer direito de exclusividade por
            quaisquer das Partes.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Fica expressa e irrevogavelmente estabelecido que a tolerância com o atraso ou descumprimento de obrigações
            da outra Parte, bem como o não exercício, pelas Partes, de quaisquer direitos assegurados neste Contrato ou
            na lei em geral, não importará em novação contratual ou renúncia a qualquer desses direitos, podendo as
            Partes exercitá-los a qualquer tempo.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            O Contrato obriga, além das Partes contratantes, seus sucessores, qualquer que seja a forma de sucessão, em
            todos os direitos e obrigações assumidas por força do Contrato, obrigando-se ainda a CONTRATADA a não
            delegar ou transferir a terceiros, no todo ou em parte, os serviços objeto deste contrato, sem prévia e
            expressa anuência da CONTRATANTE.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.6 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            As Partes declaram, sob as penas da lei, que os procuradores e/ou representantes legais abaixo subscritos se
            encontram devidamente nomeados na forma dos respectivos Estatutos ou Contratos Sociais, com poderes para
            assumir as obrigações ora contraídas.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.7 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Toda e qualquer Proposta da CONTRATADA, posterior à data de início de vigência deste Contrato, uma vez
            assinada/rubricada pelas Partes, ainda que eventualmente não faça expressa referência a este instrumento,
            estará vinculada e passará a fazer parte integrante do mesmo, para todos os fins e efeitos de direito.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            11.7 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Além da previsão de cláusula 6.2, antes do período mínimo de vigência, a CONTRATADA poderá alterar seus
            valores de serviço a partir do momento em que o negócio em questão se torne desproporcionalmente oneroso
            para ela.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA DÉCIMA SEGUNDA - DA PROPRIEDADE INTELECTUAL </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            12.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATADA garante que não infringe e não infringirá direitos à propriedade intelectual/autoral/industrial
            de qualquer terceiro, bem como que nenhum item, parte ou componente dos serviços ora contratados.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            12.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Cada parte detém, individualmente, seus respectivos direitos sobre seus projetos, logotipos, marcas,
            patentes, segredos de negócio, obras autorais, bem como quaisquer outros direitos de propriedade intelectual
            e/ou industrial que venham a ser criados, desenvolvidos ou modificados durante a vigência deste Contrato.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            12.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Nenhum direito de propriedade intelectual e/ou industrial, atualmente existente, ou que venha a ser obtido,
            adquirido ou licenciado por uma Parte, antes ou após a assinatura do presente Contrato, será transferido ou
            licenciado à outra Parte, a não ser através de contratos de licença de uso ou cessão de direitos, que
            deverão ser sempre escritos e assinados por ambas as Partes.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA DÉCIMA TERCEIRA – DA PROTEÇÃO DE DADOS PESSOAIS </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            13.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Caso, em razão da prestação de serviços objeto do contrato, haja o processamento de dados pessoais
            (informações relativas a uma pessoa identificada ou identificável, ou o conjunto de informações distintas
            que possam levar à identificação de uma determinada pessoa), as Partes deverão observar as determinações
            previstas na Lei n. 13.709/2018 (Lei Geral de Proteção de Dados). A CONTRATADA, como Operadora,
            compromete-se a obedecer aos critérios repassados pela CONTRATANTE, enquadrada como Controladora nessa
            relação, desde que os critérios repassados não contrariem a lei aplicável.
            </td>
        </tr>

        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.1.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATANTE assume exclusiva responsabilidade em obter o consentimento dos titulares de dados
            protegidos pela Lei Geral de Proteção de Dados, a serem compartilhados e armazenados pela CONTRATADA,
            eximindo essa última de qualquer responsabilidade nesse sentido.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            13.1.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Eventuais pedidos de exercício de direitos dos titulares de Dados Pessoais deverão ser direcionados à
            CONTRATANTE.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            13.1.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Em eventuais audiências ou inspeções de órgãos regulatórios, as Partes concordam em auxiliarem uma à
            outra no que for necessário e com o menor prazo possível.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            13.2 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            No caso de rescisão, resolução, ou ainda, qualquer forma de extinção do presente contrato ou fim do ciclo de
            vida dos dados pessoais, a CONTRATADA devolverá todos os arquivos adquiridos por meio físico em até 30
            (trinta) dias. Os arquivos digitais, não passíveis de devolução, serão deletados de modo irreversível,
            observando os critérios de tecnologia que a CONTRATADA utiliza para excluir definitivamente os seus próprios
            arquivos.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            13.3 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Em caso de serviço prestado mediante alocação de recursos, ou seja, mediante infraestrutura da CONTRATANTE,
            as cláusulas acima não serão aplicáveis, vez que, a responsabilidade como Operadora e Controladora será
            única e exclusiva da CONTRATANTE, devendo prover tecnologia adequada para tanto.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.4 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            Sendo o software passível de inserção de dados pessoais pela CONTRATANTE, esta será responsável em caso de
            vazamentos, roubo, comercialização ou incidentes, afastando a responsabilidade da CONTRATADA.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>
        <p>
        <table>
        <tr>
            <td valign=top>
            13.5 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>
            A CONTRATADA apenas será responsável nas hipóteses em que, comprovadamente, não houver seguido as instruções
            lícitas da CONTRATANTE, ou houver descumprido, diretamente, as obrigações da legislação de proteção de
            dados, responsabilidade sempre limitada ao valor deste contrato.
            </td>
        </tr>
        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <p>
        <strong> CLÁUSULA DÉCIMA QUARTA - DO FORO </strong>
        </p>

        <p>
        <table>
        <tr>
            <td valign=top>
            14.1 &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
            </td>
            <td>

            <p>
                As partes convencionam que, qualquer controvérsia relativa à interpretação ou execução do presente contrato,
                ou de qualquer forma oriunda ou associada a ele, e que não seja resolvida de forma amigável entre as Partes,
                deverá ser dirimida de forma definitiva por Arbitragem, nos termos da Lei ° 9.307/96.
            </p>

            <p>
                As Partes desde já acordam, que o presente Contrato será assinado eletronicamente, via plataforma Clicksign, cuja validade para todos os fins é reconhecida pelos signatários, nos termos do artigo 10º, §2º, da MP 2.200-2/2001. Ou, a critério da CONTRATANTE, poderá ser assinado por outros meios, inclusive fisicamente.
            </p>

            <p>
                E, por estarem assim justas e contratadas, as Partes assinam o presente instrumento na presença das testemunhas abaixo.
            </p>
            </td>



        </tr>

        <tr>
            <td>
            &nbsp
            </td>
        </tr>
        </table>
        </p>

        <br>
    </td>
    </tr>
    <tr>
    <td align="center" height='60px'>
        <p style="text-align: center; margin-top: 50px;">
        São Paulo, {{contractstart}}
        </p>

        <p style="text-align: center; margin-top: 80px;">
        <span>
            ___________________________________________________<br>
            {{companyname}}<br>
        </span>
        </p>

        <p style="text-align: center; margin-top: 80px;">
        <span>
            <strong> CONTRATANTE </strong>
        </span>
        </p>


        <p style="text-align: center; margin-top: 80px;">
        <span>
            ___________________________________________________<br>
            <strong>FCAMARA CONSULTORIA E FORMACAO EM INFORMATICA LTDA
            CONTRATANTE</strong>
        </span>
        </p>
        </br>

    </td>
    </tr>
    <tr>
    <td>

        <!-- TESTEMUNHASSSS -->
        <p>
        <strong>Testemunhas:</strong>
        </p>

        <div class="testemunhas" style="margin: 0; text-align: left;">
        <table style="width: 100%;">
            <thead></thead>
            <tbody>
            <tr>
                <td>
                <span>
                    1. __________________________________<br>
                    Nome:<br>
                    CPF/MF:<br>
                </span>
                </td>
                <td>
                ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
                </td>
                <td>
                <span>
                    2. __________________________________<br>
                    Nome:<br>
                    CPF/MF:<br>
                </span>
                </td>
            </tr>
            </tbody>
        </table>
        </div>
    </td>
    </tr>
    </table>
`;

export default serviceAgreementFCnuvemManagedServices;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentCompanyTemplates/ManagedServices.ts